module.exports = __webpack_public_path__ + "img/BANNER_MDT_ETPA2.384afae5.jpg";